<template>
  <section id="slots_container">
    <div class="columns">
      <div class="column">
        <CompanySelector v-model="company"/>
      </div>
      <div class="column">
        <b-field label="Código *">
          <b-input
              placeholder="Ingrese un código..."
              type="text"
              v-model="code"
              name="code"
              maxlength="10"
              v-validate="'required'"
          ></b-input>
        </b-field>
        <span class="show-error">{{ errors.first("code") }}</span>
      </div>
      <div class="column">
        <b-field label="Descripción *">
          <b-input
              placeholder="Descripción"
              type="text"
              name="description"
              v-model="description"
              v-validate="'required'"
          ></b-input>
        </b-field>
        <span class="show-error">{{ errors.first("description") }}</span>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <b-field label="Cupo Total *">
          <b-input
              placeholder="Ingrese un valor..."
              type="text"
              v-model="quota"
              v-validate="'required|numeric|min_value:0'"
              name="quota"
          ></b-input>
        </b-field>
        <span class="show-error">{{ errors.first("quota") }}</span>
      </div>
      <div class="column is-4">
        <b-field label="Lote Padre">
          <treeselect
              :options="fathers"
              :show-count="true"
              v-model="father"
              name="father"
              placeholder="Seleccione un lote"
          />
        </b-field>
      </div>
      <div class="column">
        <b-field label="Tipos de espacios">
          <treeselect
              :options="listSpaceType"
              :show-count="true"
              v-model="spaceType"
              name="spaceType"
              placeholder="Seleccione un tipo"
          />
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <b-field label="Número Inicial">
          <b-input
              placeholder="Digite un número"
              type="number"
              name="numberStar"
              v-model="numberStar"
          ></b-input>
        </b-field>
        <span class="show-error">{{ errors.first("numberStar") }}</span>
      </div>
      <div class="column is-4">
        <b-field label="Número Final">
          <b-input
              placeholder="Digite un número"
              type="number"
              name="numberEnds"
              v-model="numberEnds"
          ></b-input>
        </b-field>
        <span class="show-error">{{ errors.first("numberEnds") }}</span>
      </div>

      <div class="column is-4">
        <div>
          <b-field label="Seleccione un color">
            <b-colorpicker
                v-model="colorHex"
                title="Click aquí!"/>
          </b-field>
          <!-- <colorPickerIndex v-model="color" />-->
        </div>
      </div>
    </div>
    <div class="columns" v-if="isControlSlot">
      <div class="column is-4">
        <b-field label="Tiempo de paso lote principal a sublote">
          <b-input
              placeholder="Tiempo en minutos"
              type="number"
              name="numberEnds"
              v-model="entryTimeRequired"/>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Tiempo de paso sublote a lote principal">
          <b-input
              placeholder="Tiempo en minutos"
              type="number"
              name="numberEnds"
              v-model="outTimeRequired"/>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field label="Condición de pago">
          <b-checkbox v-model="requiresPayment" true-value="Y" false-value="N">
            Obliga pago entrada sublote
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <b-field>
          <b-checkbox v-model="restrictQuota" true-value="YES" false-value="NO">
            Restringir Cupo
          </b-checkbox>
        </b-field>
      </div>
      <div class="column is-4">
        <b-field>
          <b-checkbox
              v-model="config.scheduleRestriction"
              true-value="Y"
              false-value="N"
          >
            Restringir Horario
          </b-checkbox>
        </b-field>
      </div>
    </div>
    <div class="buttons button-group">
      <b-button @click="save()" type="is-info"> Guardar</b-button>
      <b-button @click="cleanForm()" class="ml-2" type="is-default">
        Limpiar formulario
      </b-button>
      <b-button
          v-if="selected != null"
          @click="openDeleteModal()"
          type="is-danger"
          icon-right="delete"
          class="ml-2"
      >
        Eliminar
      </b-button>
      <b-button
          @click="downloadPdf()"
          :disabled="!company || tableData.length === 0"
          :title="!company || tableData.length === 0 ? 'No hay lotes para exportar' : ''"
          icon-right="download"
          class="ml-2"
      >
        Descargar PDF
      </b-button>
    </div>
    <div class="columns">
      <div class="column">
        <b-table :data="tableData" :selected.sync="selected" focusable>
          <b-table-column field="company" label="Empresa" v-slot="props">
            {{ props.row.company.name }}
          </b-table-column>
          <b-table-column field="type" label="Código" v-slot="props">
            <b-tag type="is-info" title="Código de lote" class="cursor-pointer">
              {{ props.row.id }}
            </b-tag>
          </b-table-column>
          <b-table-column field="date" label="Descripción" v-slot="props">
            {{ props.row.title }}
          </b-table-column>
          <b-table-column field="type" label="Cupo Total" v-slot="props">
            {{ props.row.quota }}
          </b-table-column>
          <b-table-column field="occupied" label="Cupos ocupados" v-slot="props">
            {{ occupancyByCode[props.row.code] ? occupancyByCode[props.row.code].quantityBusy : 0 }}
          </b-table-column>
          <b-table-column field="available" label="Cupos disponibles" v-slot="props">
            {{ occupancyByCode[props.row.code] ? occupancyByCode[props.row.code].quotaAvailable : props.row.quota }}
          </b-table-column>
          <b-table-column field="company" label="Lote Padre" v-slot="props">
            {{ props.row.father.title }}
          </b-table-column>
          <b-table-column field="company" label="Tipo espacio" v-slot="props">
            {{ props.row.sectionType.title }}
          </b-table-column>
          <b-table-column field="company" label="Número inicia" v-slot="props">
            {{ props.row.initialNumber }}
          </b-table-column>
          <b-table-column field="company" label="Número final" v-slot="props">
            {{ props.row.finalNumber }}
          </b-table-column>
          <div style="display: none">
            <b-table-column field="company" label="Color" v-slot="props">
              {{ props.row.colorHex }}
            </b-table-column>
          </div>
          <template #empty>
            <div class="has-text-centered">Sin registros</div>
          </template>
        </b-table>
      </div>
    </div>
    <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
  </section>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import {confirmation} from "@/global/utils";
import {get as getProp} from "object-path";
import CompanySelector from "@/components/Shared/CompanySelector";
import slotEndpoint from "@/endpoints/core/SlotEndpoint";
import unityEndpoint from "@/endpoints/core/UnityEndpoint";
import parkingReportsEndpoints from "@/endpoints/reports/parking-reports/parkingReportsEndpoints";
import downloadEndpoint from "@/endpoints/download/downloadEndpoint";
import toast from "@/global/ToastConfig";

export default {
  name: "CreateSlot",
  components: {CompanySelector},
  data: () => ({
    id: null,
    company: null,
    code: null,
    description: null,
    quota: null,
    restrictQuota: "NO",
    selected: null,
    father: null,
    isLoading: false,
    companies: [],
    realFathers: [],
    fathers: [],
    counter: [],
    tableData: [],
    occupancyByCode: {},
    listSpaceType: [],
    spaceType: null,
    numberStar: null,
    numberEnds: null,
    colorHex: "#0070FF",
    isControlSlot: false,
    controlSlotLabel: 'Control Sublote',
    requiresPayment: "N",
    entryTimeRequired: null,
    outTimeRequired: null,
    config: {
      scheduleRestriction: 'N'
    }
  }),
  watch: {
    company(value) {
      if (!this.company) {
        this.selected = null;
        this.tableData = [];
        this.occupancyByCode = {};
        return;
      }
      if (value != null) {
        this.getSlots(value);
        this.getFathers(value);
      }
    },
    selected() {
      if (this.selected != null) {
        this.fillData(this.selected);
      }
    },
    spaceType() {
      if (this.compareSectionType(this.spaceType) === this.controlSlotLabel) {
        this.isControlSlot = true;
        return;
      }
      this.isControlSlot = false;
    }
  },
  async mounted() {
    this.getCompanies();
    this.listSpaceType = await unityEndpoint.listUnitySpaceType();

  },

  methods: {
    /**
     * Método que realiza la validación del tipo de espacio seleccionado para controlSublote
     * @param unityToFind
     * @returns {*}
     */
    compareSectionType(unityToFind) {
      const unityFound = this.listSpaceType.find(space => space.code === unityToFind);
      return unityFound.title;
    },
    fillData(selected) {
      this.id = selected.code;
      this.company = selected.company.code;
      this.code = selected.id;
      this.description = selected.title;
      this.quota = selected.quota;
      this.restrictQuota = selected.restrictQuota;
      this.father = selected.father.code;
      this.spaceType = selected.sectionType.code;
      this.numberStar = selected.initialNumber;
      this.numberEnds = selected.finalNumber;
      this.colorHex = selected.colorHex;
      this.requiresPayment = selected.requiresPayment;
      this.entryTimeRequired = selected.entryTimeRequired;
      this.outTimeRequired = selected.outTimeRequired;
      this.config.scheduleRestriction = selected.config.scheduleRestriction;
    },
    getSlots(companyId) {
      try {
        this.isLoading = true;
        // Se piden en paralelo: el listado (con los datos completos que
        // necesita fillData para editar) y la ocupación (liviana, solo
        // code/quantityBusy/quotaAvailable) para no duplicar lógica ni
        // acoplar la edición de lotes a la consulta de ocupación.
        Promise.all([
          slotEndpoint.listByCompany(companyId),
          slotEndpoint.listOccupancyByCompany(companyId)
        ]).then(([slots, occupancy]) => {
          this.isLoading = false;
          this.tableData = slots;
          this.occupancyByCode = occupancy.reduce((byCode, item) => {
            byCode[item.code] = item;
            return byCode;
          }, {});
        });
      } catch (error) {
        this.isLoading = false;
        toast.error(error);
      }
    },
    getChildFathers(list, father) {
      father.children = list.filter(
          (item) => getProp(item, "father.code") === father.code
      );
      father.children.forEach((f) => {
        this.getChildFathers(list, f);
      });
    },
    groupFathers(list) {
      const fathers = list.filter((item) => !item.father);
      fathers.forEach((father) => {
        this.getChildFathers(list, father);
      });
      return fathers;
    },
    getFathers(companyId) {
      try {
        this.isLoading = true;
        slotEndpoint.listAllByCompany(companyId)
            .then(data => {
              this.isLoading = false;
              this.realFathers = [...data.info];
              this.processData(data.info);
              this.fathers = this.groupFathers(data.info);
            });
      } catch (error) {
        this.isLoading = false;
        toast.error(error);
      }
    },
    openDeleteModal() {
      confirmation(
          this,
          `¿Desea eliminar el lote ${this.selected.title}?`
      ).then((result) => {
        if (!result) {
          return;
        }
        this.deleteSloth();
      });
    },
    deleteSloth() {
      try {
        this.isLoading = true;
        const company = this.company;
        slotEndpoint.deleteSloth(this.selected.code)
            .then(result => {
              this.isLoading = false;
              this.cleanForm();
              // cleanForm() limpia también la empresa y la tabla; se restaura
              // aquí para que el watcher de "company" vuelva a cargar lotes
              // y ocupación de la misma empresa (la tabla no debe quedar vacía
              // tras eliminar un lote).
              this.company = company;
            });

      } catch (error) {
        this.isLoading = false;
        toast.error(error);
      }
    },
    /**
     * Descarga el reporte de ocupación de lotes (cupo total, ocupados y
     * disponibles) de la empresa seleccionada en formato PDF. El botón ya
     * queda deshabilitado sin empresa/lotes cargados; esta validación es un
     * respaldo para no disparar la petición en ese caso.
     */
    downloadPdf() {
      if (!this.company || this.tableData.length === 0) {
        toast.info("No hay lotes para exportar");
        return;
      }
      this.isLoading = true;
      parkingReportsEndpoints.downloadSlotOccupancy({
        companyId: this.company,
        type: "pdf"
      }).then(data => {
        this.isLoading = false;
        if (data.code < 0) {
          return;
        }
        downloadEndpoint.downloadFile(data.info);
      });
    },
    cleanForm() {
      this.id = null;
      this.company = null;
      this.quota = null;
      this.code = null;
      this.description = null;
      this.father = null;
      this.selected = null;
      this.restrictQuota = "NO";
      this.isLoading = false;
      this.tableData = [];
      this.occupancyByCode = {};
      this.fathers = [];
      this.spaceType = null;
      this.isControlSlot = false;
      this.numberStar = null;
      this.numberEnds = null;
      this.requiresPayment = "N";
      this.entryTimeRequired = null;
      this.outTimeRequired = null;
      this.config.scheduleRestriction = "N";
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let companie = companies[index];
        companie.label = companie.name || companie.title;
        companie.id = companie.code;
        if (companie.children) {
          this.processData(companie.children);
        }
      }
    },
    getCompanies() {
      this.isLoading = true;
      this.$http.get(ROUTES.DASHBOARD.GET_COMPANIES_TREE).then(({data}) => {
        this.isLoading = false;
        if (data.code > 0) {
          this.companies = data.info;
          this.processData(this.companies);
        }
      });
    },
    getCalendar() {
      const company = this.company;
      this.$http
          .get(ROUTES.DASHBOARD.CALENDAR.GET_CALENDAR, {
            params: {companyId: company},
          })
          .then(({data}) => {
            if (data.code <= 0) {
              this.$buefy.toast.open({
                duration: 5000,
                message: data.message,
                type: "is-danger",
                container: "#calendar_container",
              });
              return;
            }
            this.tableData = data.info;
            this.$buefy.toast.open({
              duration: 5000,
              message: data.message,
              type: "is-success",
              container: "#calendar_container",
            });
          });
    },
    checkLimits() {
      if (this.realFathers.length == 0) {
        return {result: true};
      }
      if (this.father == null) {
        return {result: true};
      }
      const fatherSelection = this.realFathers.find(
          (item) => item.code == this.father
      );
      if (!fatherSelection) {
        return {result: false};
      }
      let totalQuotaChildren = 0;
      this.realFathers.forEach((father) => {
        if (father.father != undefined) {
          totalQuotaChildren += father.father.code == fatherSelection.code ? father.quota : 0;
        }
      });
      let totalQuota = 0;
      totalQuota = (Number(this.quota) + Number(totalQuotaChildren));
      return {
        result: totalQuota <= fatherSelection.quota,
        quota: fatherSelection.quota,
      };
    },
    checkFatherLimits() {
      if (this.realFathers.length == 0) {
        return {result: true};
      }
      const father = this.realFathers.find((item) => !item.father);
      const children = this.realFathers.filter((item) => item.father);
      if (!father || children.length === 0) {
        return {result: true};
      }
      const fatherSelection = this.realFathers.find(
          (item) => item.code == this.father
      );
      let total = 0;
      children.forEach((child) => {
        total += child.quota;
      });
      total += parseInt(this.quota);
      if (total > father.quota) {
        return {result: false, quota: fatherSelection.quota};
      }
      return {result: true};
    },
    save() {
      this.$validator.validateAll().then((result) => {

        const checkLimits = this.checkLimits();
        const checkFatherLimit = this.checkFatherLimits();
        if (!result || !checkLimits.result) {
          const message = !checkFatherLimit.result
              ? `Estás superando el cupo total(${checkFatherLimit.quota}) del lote padre seleccionado`
              : !checkLimits.result
                  ? `Este lote supera el cupo total(${checkLimits.quota}) del lote padre`
                  : "Complete el formulario";
          toast.error(message);
          return;
        }
        const {
          code,
          description,
          company,
          id,
          father,
          quota,
          restrictQuota,
          spaceType,
          numberStar,
          numberEnds,
          colorHex,
          requiresPayment,
          entryTimeRequired,
          outTimeRequired
        } = this;
        const send = {
          code: id,
          id: code,
          title: description,
          company: {
            code: company,
          },
          father: {
            code: father,
          },
          quota: quota,
          restrictQuota: restrictQuota,
          sectionType: {
            code: spaceType,
          },
          initialNumber: numberStar,
          finalNumber: numberEnds,
          colorHex: colorHex.toString('hex'),
          requiresPayment: requiresPayment,
          entryTimeRequired: entryTimeRequired === null ? 0 : entryTimeRequired,
          outTimeRequired: outTimeRequired === null ? 0 : outTimeRequired,
          config: {
            scheduleRestriction: this.config.scheduleRestriction
          }
        };
        if (id == null) {
          delete send.code;
        }
        if (father == null) {
          delete send.father;
        }
        this.isLoading = true;
        slotEndpoint.save(send)
            .then(result => {
              this.getSlots(this.company);
              this.getFathers(this.company);
              this.isLoading = false;
            });
      });
    },
  },
};
</script>
<style type="scss">
.btn-save {
  display: flex;
  margin: 0 auto;
  width: 30%;
  justify-content: center;
}

.label {
  font-size: 1em;
}

.header-modal {
  background-color: #2962ff;
}

.modal-button-custom {
  padding: 5px;
  width: 35px;
  height: 35px;
  border-radius: 20px;
  margin-top: 25px;
}

.button-group {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 1.5em;
}

.buttons .button:not(:last-child):not(.is-fullwidth) {
  margin-right: 0.1rem !important;
}

.notices {
  z-index: 1000000000000000000 !important;
}
</style>
